import { cn } from '@/utils/styles';
import { Slot } from '@radix-ui/react-slot';
import { ChevronRightIcon } from '@/components/icons/ChevronRightIcon';

export interface ListItemProps extends React.ComponentProps<'li'> {
  asChild?: boolean;
  hideIndicator?: boolean;
}

export const ListItem = ({
  asChild,
  children,
  className,
  hideIndicator,
  ...rest
}: ListItemProps) => {
  const Comp = asChild ? Slot : 'div';

  return (
    <li
      className="relative text-primary border-b border-stroke-secondary-subtle overflow-hidden"
      {...rest}
    >
      <Comp
        data-indicator={!hideIndicator}
        className={cn(
          'h-12 flex flex-row justify-start items-center px-5 w-full [&_svg]:!size-6 typography-btn-large text-primary data-[indicator=true]:pr-8 gap-4',
          className,
        )}
      >
        {children}
      </Comp>

      {!hideIndicator && (
        <ChevronRightIcon
          width={24}
          height={24}
          aria-hidden
          className="absolute right-4 top-1/2 -translate-y-1/2 text-tertiary pointer-events-none"
        />
      )}
    </li>
  );
};

export type ListProps = React.ComponentProps<'ul'>;

export const List = ({ children, className, ...rest }: ListProps) => {
  return (
    <ul {...rest} className={cn('[&>li:last-child]:border-b-0', className)}>
      {children}
    </ul>
  );
};
